var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerConnectivitySelfmgt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.8435C1.45 18.8435 0.979167 18.6477 0.5875 18.256C0.195833 17.8643 0 17.3935 0 16.8435V2.84351C0 2.29351 0.195833 1.82267 0.5875 1.43101C0.979167 1.03934 1.45 0.843506 2 0.843506H18C18.55 0.843506 19.0208 1.03934 19.4125 1.43101C19.8042 1.82267 20 2.29351 20 2.84351V16.8435C20 17.3935 19.8042 17.8643 19.4125 18.256C19.0208 18.6477 18.55 18.8435 18 18.8435H2ZM2 16.8435H18V2.84351H2V16.8435ZM3 14.8435H8V12.8435H3V14.8435ZM12.55 12.8435L17.5 7.89351L16.075 6.46851L12.55 10.0185L11.125 8.59351L9.725 10.0185L12.55 12.8435ZM3 10.8435H8V8.84351H3V10.8435ZM3 6.84351H8V4.84351H3V6.84351Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerConnectivitySelfmgt);
export default __webpack_public_path__ + "static/media/tower_connectivity_selfmgt.b8abaa486e3424d4eb0ff450432352de.svg";
export { ForwardRef as ReactComponent };